import React, { useContext, useEffect, useState } from 'react';
import Styles from './PlayerInsightLoadingWithMessages.module.scss';
import APIClient from '../../../helpers/APIClient';
import { LocalizationContext } from '../../../context/localizationContext';
import { insightsContext } from '../../../context/insightsContext';
import PlayerInsightLoadingSpinner from './PlayerInsightLoadingSpinner/PlayerInsightLoadingSpinner';

const LoadingWithMessages = (props) => {
  const { setLoading } = props;
  const localization = useContext(LocalizationContext);
  const { tileText } = localization;
  const { loadingMessages } = tileText;
  const insights = useContext(insightsContext);
  const { state, dispatch } = insights;
  const { data } = state;
  const [topText, setTopText] = useState(loadingMessages[0]?.topText);
  const [bottomText, setBottomText] = useState(loadingMessages[0]?.bottomText);

  useEffect(() => {
    loadingMessages.forEach((message, i) => {
      setTimeout(() => {
        setTopText(message.topText);
        setBottomText(message.bottomText);
        if (i === loadingMessages.length - 1) {
          setTimeout(() => {
            if (!data) {
              APIClient.getInsights((res, response) => {
                dispatch({ type: 'ADD_INSIGHTS', data: response.data });
              });
            }
            setLoading(false);
          }, 500);
        }
      }, i * 2000);
    });
  }, []);

  return (
    <div className={Styles.loading}>
      <div className={Styles.topText}>{topText}</div>
      <PlayerInsightLoadingSpinner color={'light'} />
      <div className={Styles.bottomText}>{bottomText}</div>
    </div>
  );
};

export default LoadingWithMessages;
